import type React from 'react';
import { FormField, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../../models';
import { LIVING_SPACE_FLOODING } from '../../../../constants';
import YesAndNo from '../../../Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function LivingSpaceFlooding({ section, setSectionValues }: Props) {
  function onNoFloodZone(): void {
    setSectionValues({
      [LIVING_SPACE_FLOODING.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesFloodZone(): void {
    setSectionValues({
      [LIVING_SPACE_FLOODING.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onFloodingDescriptionChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({ [LIVING_SPACE_FLOODING.FIELD_NAME.DESCRIPTION]: value });
  }

  return (
    <>
      <FormField
        required
        label={
          <Label>
            Has any portion of the property’s living space been damaged by flooding at least 3 times during the last 5
            years?
          </Label>
        }
        control={
          <YesAndNo
            yesHandler={onYesFloodZone}
            noHandler={onNoFloodZone}
            yesActive={section.getFieldValue(LIVING_SPACE_FLOODING.FIELD_NAME.IS_ENABLED)}
          />
        }
      />
      {section.getFieldValue(LIVING_SPACE_FLOODING.FIELD_NAME.IS_ENABLED) && (
        <FormField
          required
          css={{ marginTop: 'layout.tight' }}
          label={<Label>Describe the tendency of the property to flood</Label>}
          control={
            <Textarea
              css={{ resize: 'vertical' }}
              value={section.getFieldValue(LIVING_SPACE_FLOODING.FIELD_NAME.DESCRIPTION)}
              onChange={onFloodingDescriptionChange}
            />
          }
        />
      )}
    </>
  );
}

LivingSpaceFlooding.description = 'Flooding for Georgia';

export default LivingSpaceFlooding;
